module.exports = __webpack_public_path__ + "static/media/kr.c7593944.svg";